import { render, staticRenderFns } from "./AdminDashboardPage.vue?vue&type=template&id=eb89eb00&"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports